import { Component, input} from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';

@Component({
  selector: 'afcu-loading',
  standalone: true,
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
export class LoadingComponent extends BaseConfigurableComponent{

  target = input.required<string>()

  constructor () {
    super('loading')
  }
}
